(function () {
  if (window.__outisanTechScaleFallback) return;
  try {
    if (window.CSS && window.CSS.supports('opacity', 'calc(100px / 100px)')) return;
  } catch (error) {
    // Older engines may reject the feature query as well as the expression.
  }
  window.__outisanTechScaleFallback = true;

  var entries = [];
  var header = null;
  var scheduled = false;
  var observer = window.ResizeObserver ? new window.ResizeObserver(schedule) : null;

  function setNumber(element, name, value) {
    var next = String(parseFloat(value.toFixed(8)));
    if (element.style.getPropertyValue(name) !== next) element.style.setProperty(name, next);
  }

  function setLength(element, name, value) {
    var next = String(parseFloat(value.toFixed(8))) + 'px';
    if (element.style.getPropertyValue(name) !== next) element.style.setProperty(name, next);
  }

  function registerSections() {
    var wrappers = document.querySelectorAll('.shopify-section.tch-wrap');
    Array.prototype.forEach.call(wrappers, function (wrapper) {
      var exists = entries.some(function (entry) { return entry.wrapper === wrapper; });
      if (exists) return;
      entries.push({ wrapper: wrapper });
      if (observer) observer.observe(wrapper);
    });

    var nextHeader = document.querySelector('.section-header .header') || document.querySelector('header.header');
    if (nextHeader === header) return;
    if (observer && header) observer.unobserve(header);
    header = nextHeader;
    if (observer && header) observer.observe(header);
  }

  function pageWidth() {
    var raw = window.getComputedStyle(document.documentElement).getPropertyValue('--page-width').trim();
    if (!raw || !document.body) return null;
    var probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:fixed;left:0;top:0;display:block;height:0;padding:0;margin:0;border:0;max-width:none;box-sizing:border-box;visibility:hidden;pointer-events:none;overflow:hidden;';
    probe.style.width = raw;
    if (!probe.style.width) return null;
    document.body.appendChild(probe);
    var width = probe.getBoundingClientRect().width;
    document.body.removeChild(probe);
    return width > 0 ? width : null;
  }

  function measure() {
    scheduled = false;
    var viewport = window.innerWidth || document.documentElement.clientWidth;
    var rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 10;
    var headerContent = null;
    if (header && document.documentElement.contains(header)) {
      var headerStyle = window.getComputedStyle(header);
      var headerWidth = header.getBoundingClientRect().width;
      if (headerWidth > 0) {
        headerContent = Math.max(0, headerWidth - (parseFloat(headerStyle.paddingLeft) || 0) - (parseFloat(headerStyle.paddingRight) || 0));
      }
    }
    var configuredPageWidth = headerContent === null && viewport >= 990 ? pageWidth() : null;

    entries.forEach(function (entry) {
      var wrapper = entry.wrapper;
      if (!document.documentElement.contains(wrapper)) return;
      var width = wrapper.getBoundingClientRect().width;
      if (width <= 0) return;
      var artboardScale = Math.min(1, viewport / 2560);
      var desktopScale = Math.min(1, Math.max(0, (width - 48) / 1340));
      if (viewport >= 990) {
        var content = headerContent;
        if (content === null) {
          content = configuredPageWidth === null
            ? 1340 * artboardScale
            : Math.max(0, Math.min(width, configuredPageWidth) - 10 * rootFontSize);
        }
        desktopScale = Math.max(0, Math.min((width - 48) / 1340, Math.max(1340 * artboardScale, content) / 1340));
      }

      Array.prototype.forEach.call(wrapper.querySelectorAll('.tch'), function (root) {
        var isNav = root.classList.contains('tch-nav');
        setNumber(root, '--tch-m', (isNav ? viewport : width) / 430);
        setNumber(root, '--tch-s', desktopScale);
        setNumber(root, '--tch-hero-s', Math.min(1, width / 2560));
        if (root.classList.contains('tch-scenes')) {
          setLength(root, '--tch-scene-inset', Math.max(24, (width - 1340 * desktopScale) / 2));
        }
        if (isNav) setNumber(wrapper, '--tch-m', viewport / 430);
      });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(measure);
    else window.setTimeout(measure, 16);
  }

  function refresh() {
    registerSections();
    measure();
  }

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', function (event) {
    entries = entries.filter(function (entry) {
      var remove = entry.wrapper === event.target || event.target.contains(entry.wrapper);
      if (remove && observer) observer.unobserve(entry.wrapper);
      return !remove;
    });
    if (header && (header === event.target || event.target.contains(header))) {
      if (observer) observer.unobserve(header);
      header = null;
    }
    schedule();
  });
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  refresh();
})();
